import React, { useCallback, useEffect, useState } from 'react';
import styles from './JobseekerProfileEmployerViewBody.module.css';
import AboutMe from './AboutMe';
import OverView from './OverView';
import Education from './Education';
import WorkExperience from './WorkExperience';
import { useNavigate } from 'react-router-dom';
import { TopRightArrow } from '../../../../assets/images/icons';
import { useTranslation } from 'react-i18next';
import { fetchJobsByEmployer } from '../../../../services/jobService';

function EmployerProfileJobseekerViewBody({ employer, hide_url_params = false, setActiveTab, blur, activeTab, sectionRefs, handleBlur, setHandleBlur }) {

    const navigate = useNavigate();
    const { t } = useTranslation();

    const [recentJob, setRecentJob] = useState([])
    const [totalPages, setTotalPages] = useState(1);

    const getRecentJob = async () => {
        const MAX_RETRIES = 1000; // Maximum retries
        let retryCount = 0;

        setPaginationLoading(true);
        try {
            if (employer?.id) {
                const fetchedJobs = await fetchJobsByEmployer(employer.id, 1, activeTab === 'jobs' ? 10 : 2); // Show more jobs in jobs tab
                setRecentJob(fetchedJobs.jobs);
                setTotalPages(fetchedJobs.totalPages);
                setPaginationLoading(false);
            }
        } catch (error) {
            if (error.error === 'out of shared memory' && retryCount < MAX_RETRIES) {
                retryCount++;
                console.log(`Retrying... Attempt ${retryCount}`);
                getRecentJob();
            } else {
                console.error('Failed to fetch jobs after retries:', error);
                setPaginationLoading(false);
            }
        } finally {
            setPaginationLoading(false);
        }
    };
    
    useEffect(() => {
        if (employer?.id) { getRecentJob() }
    }, [employer, activeTab])
    
    const [paginationLoading, setPaginationLoading] = useState(false);

    // Custom CSS for scrollable job container
    const scrollableJobsStyle = {
        maxHeight: activeTab === 'jobs' ? '600px' : 'auto',
        overflowY: activeTab === 'jobs' ? 'auto' : 'visible',
        padding: activeTab === 'jobs' ? '0 10px 0 0' : '0', // Add padding for scrollbar
    };
    
    return (
        <div style={{ position: 'relative' }} className='employerProfileBodyContainer'>
            <div className={`${blur && styles.blur} ${styles.container}`} >
                <div className={styles.wrapper}>
                    <div className={styles.aboutMe} style={{ padding: 0 }}>
                        {activeTab == 'jobs' ?
                            <>
                                <div style={scrollableJobsStyle}>
                                    <WorkExperience activeTab={activeTab} paginationLoading={paginationLoading} jobs={recentJob} ref={sectionRefs.workExperience} />
                                </div>
                            </>
                            :
                            <>
                                {employer?.employer_status == 'buisness' ? employer?.company_description &&
                                    <>
                                        <AboutMe jobseeker={employer} ref={sectionRefs.aboutMe} />
                                        <div className={styles.saperator} >
                                            <div className={styles.leftCorner}></div>
                                            <div className={styles.rightCorner}></div>
                                        </div>
                                    </>
                                    :
                                    employer?.description &&
                                    <>
                                        <AboutMe jobseeker={employer} ref={sectionRefs.aboutMe} />
                                        <div className={styles.saperator} >
                                            <div className={styles.leftCorner}></div>
                                            <div className={styles.rightCorner}></div>
                                        </div>
                                    </>
                                }

                                <>
                                    <WorkExperience activeTab={activeTab} paginationLoading={paginationLoading} jobs={recentJob.slice(0, 2)} ref={sectionRefs.workExperience} />
                                    <div style={{ display: "flex", justifyContent: "flex-start", }}>
                                        <div
                                            onClick={() => {
                                                setActiveTab('jobs')
                                                const target = document.querySelector('.employerProfileBodyContainer')
                                                if (target) {
                                                    window.scrollTo({
                                                        top: target.offsetTop, behavior: 'smooth'
                                                    });
                                                }
                                            }}
                                            className={styles.seeAllButtonContainer}>
                                            <p className={styles.seeAllButton}>{t(`explore_more_jobs`)}</p>
                                            <img src={TopRightArrow} alt="arrow icon" className={styles.arrowIcon} />
                                        </div>
                                    </div>
                                </>
                            </>
                        }
                    </div>
                    <div className={styles.overview}>
                        <OverView
                        setHandleBlur={setHandleBlur}
                        jobseeker={employer} ref={sectionRefs.skills} />
                    </div>
                </div>
            </div>

            {/* Decorative Circles */}
            <div className={styles.i1}></div>
            <div className={styles.i2}></div>
            <div className={styles.i3}></div>
            <div className={styles.i4}></div>
        </div >
    );
}

export default EmployerProfileJobseekerViewBody;
